var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_11896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3804 19.0333L14.9838 14.6368M2.38037 9.36093C2.38037 5.31402 5.66104 2.03335 9.70796 2.03335C13.7549 2.03335 17.0355 5.31402 17.0355 9.36093C17.0355 13.4079 13.7549 16.6885 9.70796 16.6885C5.66104 16.6885 2.38037 13.4079 2.38037 9.36093Z",
    stroke: "#353E5C",
    strokeWidth: 1.59375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_11896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.880371 0.533348)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.aa509f8d39f021d62dfcc6df98fab6fb.svg";
export { ForwardRef as ReactComponent };